var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatTab(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6213 9.33677V15.9685C18.6213 16.3202 18.4815 16.6576 18.2328 16.9063C17.9841 17.155 17.6467 17.2948 17.295 17.2948H6.68426L1.37891 18.6211L2.70525 14.6421V4.03142C2.70525 3.67965 2.84499 3.34229 3.09372 3.09355C3.34246 2.84482 3.67981 2.70508 4.03158 2.70508H10.0001",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6753 5.93931C10.217 5.85823 10.217 5.1892 10.6753 5.10812C12.3357 4.81439 13.6563 3.52836 14.0168 1.85424L14.0444 1.72591C14.1436 1.26531 14.7884 1.26244 14.8916 1.72215L14.9252 1.8717C15.2988 3.53792 16.6199 4.81308 18.2757 5.106C18.7363 5.18749 18.7363 5.85994 18.2757 5.94143C16.6199 6.23436 15.2988 7.50951 14.9252 9.17574L14.8916 9.32528C14.7884 9.78499 14.1436 9.78213 14.0444 9.32152L14.0168 9.19319C13.6563 7.51907 12.3357 6.23304 10.6753 5.93931Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatTab);
export default __webpack_public_path__ + "static/media/chat-tab.f5f71a9489372215945927883da00948.svg";
export { ForwardRef as ReactComponent };